import Vue from 'vue'
import Vuetify, { VSnackbar, VBtn, VIcon, VSkeletonLoader } from 'vuetify/lib'
// import colors from 'vuetify/lib/util/colors'
import en from 'vuetify/es5/locale/en'
import ko from 'vuetify/es5/locale/ko'
import VuetifyToast from 'vuetify-toast-snackbar'
// import 'tiptap-vuetify/dist/main.css'
// import 'vuetify/dist/vuetify.min.css'
// import { preset } from 'vue-cli-plugin-vuetify-preset-basil/preset'
// import { preset } from 'vue-cli-plugin-vuetify-preset-crane/preset'
// import { preset } from 'vue-cli-plugin-vuetify-preset-fortnightly/preset'
// import { preset } from 'vue-cli-plugin-vuetify-preset-owl/preset'
// import { preset } from 'vue-cli-plugin-vuetify-preset-rally/preset'
// import { preset } from 'vue-cli-plugin-vuetify-preset-reply/preset'
// import { preset } from 'vue-cli-plugin-vuetify-preset-shrine/preset'

Vue.use(Vuetify, {
  components: { VSnackbar, VBtn, VIcon, VSkeletonLoader }
})
Vue.use(VuetifyToast, {
  x: 'right', // default
  y: 'bottom', // default
  color: 'primary', // default
  icon: 'mdi-information',
  iconColor: '', // default
  // classes: [
  //   'body-2'
  // ],
  timeout: 0, // default
  dismissable: true, // default
  multiLine: false, // default
  vertical: false, // default
  queueable: false, // default
  showClose: true,
  closeText: '', // default
  closeIcon: 'mdi-close', // default
  closeColor: 'white', // default
  slot: [], // default
  // shorts: {
  //   custom: {
  //     color: 'purple'
  //   }
  // },
  property: '$toast' // default
})

// eslint-disable-next-line no-unused-vars
const theme = {
  themes: {
    light: {
      primary: '#025373',
      secondary: '#04ADBF', // #FFCDD2
      accent: '#F2C063',
      info: '#66CDD9',
      success: '#F29472'
    }
    // dark: {
    //   primary: colors.brown.darken1, // #E53935
    //   secondary: colors.deepPurple.lighten4, // #FFCDD2
    //   accent: colors.indigo.base // #3F51B5
    // }
  }
}
const lang = {
  locales: { en, ko },
  current: 'ko'
}
const options = {
  lang,
  theme
}

export default new Vuetify({
  // eslint-disable-next-line no-undef
  // preset,
  ...options
})
